import { Injectable }                   from '@angular/core';
import { Observable }                   from 'rxjs/Observable';
import { Observer }                     from 'rxjs/Observer';
import { JwtHelper }                    from 'angular2-jwt';
import { PortalTypeEnum }               from '../login/login.model';

@Injectable()
export class Globals {
    showProgress = false;
    showProgressUpdate: Observable<boolean>;
    showProgressObserver: Observer<boolean>;

    public roles = new Array<string>();

    public isDownloadingPdf = false;

    public isDownloadingCsv = false;

    public environment: string = null;

    public dictionary: any = {};

    public portalType: PortalTypeEnum = PortalTypeEnum.Bus;
    private _currentLang: string;

    private antiCache = '?anticache=' + new Date().getTime();

    constructor() {
        if (localStorage['PortalType'] === 'Train') {
         this.portalType = PortalTypeEnum.Train;
        }
        if (localStorage['PortalType'] === 'Bus') {
             this.portalType = PortalTypeEnum.Bus;
         }
        this.showProgressUpdate = Observable.create((observer: Observer<boolean>) => {
            this.showProgressObserver = observer;
        });
    }

    setProgress(running: boolean) {
        this.showProgress = running;
        if (!!this.showProgressObserver) {
            this.showProgressObserver.next(this.showProgress);
        }
    }

    GetUrlPrefix(): string {
        if ((<any>window).location.href.indexOf('localhost:8080') > -1) {
            // console.log('Development mode URL prefix');
            return 'http://localhost:5000';
        } else {
            return '';
        }
    }

    GetAnticacheSuffix(): string {
        return (<any>window).anticache || this.antiCache;
    }

    ShowProgress(): boolean {
        return this.showProgress;
    }

    OverrideToDev(): boolean {
        return false;
    }

    public getLanguage(): string {
        return (!!this._currentLang) ? this._currentLang : 'cs';
    }

    public setLanguage(lang: string): void {
        this._currentLang = lang;
    }

    public getRoles() {
        if (!!this.roles && this.roles.length > 0) {
            return this.roles;
        };

        let token = sessionStorage.getItem('id_token');

        if (!token) {
            return [];
        }

        let jwtHelper = new JwtHelper();
        let decodedToken = jwtHelper.decodeToken(token);
        if (!!decodedToken.roles) {
            this.roles = decodedToken.roles.split(';');

            if (!!decodedToken.environment) {
                this.environment = decodedToken.environment;
            } else {
                this.environment = null;
            }
            return this.roles;
        }
    }

    public numRequired(event) {
        console.log(event);
    }
    public isAdmin(): boolean {
        return this.getRoles().indexOf('PortalAdmin') > -1;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/common/globals.ts